import { createSlice } from "@reduxjs/toolkit";

export const morbidityRateSlice = createSlice({
    name: 'morbidity',
    initialState: {
        checked: false,
        value: {},
        population: 100000,
        theme: []
    },
    reducers: {
        setMorbidityChecked: (state, action) => {
            state.checked = action.payload;
        },
        setPopulationRate: (state, action) => {
            state.population = action.payload;
        },
        setMorbidityRate: (state, action) => {
            state.value = action.payload;
        },
        setThemeSelectedValue: (state, action) => {
            state.theme = action.payload;
        }
    }
})

export const { setMorbidityRate, setPopulationRate, setThemeSelectedValue, setMorbidityChecked } = morbidityRateSlice.actions;

export const getMorbidityRate = (state) => state.morbidity.value;
export const getPopulationRate = (state) => state.morbidity.population;
export const getThemeSelectedValue = (state) => state.morbidity.theme;
export const getMorbidityChecked = (state) => state.morbidity.checked;

export default morbidityRateSlice.reducer;